<template>
  <header>
    <div class="header-wrapper">
      <div class="portfolio-logo">
        <router-link to="/">
          <img alt="portfolio-logo" src="@/assets/images/portfolio-logo.png">
        </router-link>
      </div>
      <header-hamburger-menu></header-hamburger-menu>
    </div>
  </header>
</template>

<script>
import HeaderHamburgerMenu from '@/components/HeaderHamburgerMenu.vue';

export default {
  components: {
    HeaderHamburgerMenu
  }
};
</script>

<style lang='scss'>
header {
  display: flex;
  justify-content: center;
  height: 60px;
}

.header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 97vw;
}

.portfolio-logo {
  position: fixed;
  z-index: 999;
  a {
    display: flex;
    img {
      width: 50px;
      height: 100%;
    }
  }
}

</style>